export interface AuditActivityTypeItem {
  key: string;
  value: string;
  bu: string[];
}

const buTGI = ['TGI'];
const buTGIandVCD = ['TGI', 'VCD'];
const buDPTandCTX = ['DPT', 'CTX'];
const allBu = ['TGI', 'VCD', 'DPT', 'CTX'];


export const AuditActivityTypeList: AuditActivityTypeItem[] = [
  { key: 'LogOn', value: 'Log on', bu: allBu },
  { key: 'LogOff', value: 'Log off', bu: allBu },
  { key: 'ViewDownloadReport', value: 'View/Download report', bu: allBu },
  { key: 'PasswordChange', value: 'Password change', bu: allBu },
  { key: 'OrderCreated', value: 'Order created', bu: allBu },
  { key: 'OrderUpdated', value: 'Order updated', bu: buDPTandCTX },
  { key: 'BulkOrderUpload', value: 'Bulk order upload', bu: buDPTandCTX },
  { key: 'PrePrintedLabelsAssignment', value: 'Pre-printed labels assignment', bu: buDPTandCTX },
  { key: 'UserUpdate', value: 'User update', bu: allBu },
  { key: 'LoginFailure', value: 'Login failure', bu: allBu },
  { key: 'PatientViewed', value: 'Patient viewed', bu: buTGIandVCD },
  { key: 'PatientUpdated', value: 'Patient updated', bu: buTGIandVCD },
  { key: 'ResultPageSearched', value: 'Result page searched', bu: allBu },
  { key: 'PatientPageSearched', value: 'Patient page searched', bu: buTGIandVCD },
  { key: 'OrderPageSearched', value: 'Order page searched', bu: buTGIandVCD },
  { key: 'OrderUpdateRequested', value: 'Order update requested', bu: buTGIandVCD },
  { key: 'OrderCancellationRequested', value: 'Order cancellation requested', bu: buTGIandVCD },
  { key: 'OrderViewed', value: 'Order viewed', bu: buTGIandVCD },
  {key: 'OrderSentToLab', value: 'Order Sent to Lab', bu: buTGI},
  {key: 'OrderCancelled', value: 'Order Cancelled', bu: buTGI}
];


export const AuditActivityTypeArgs = Object.entries(AuditActivityTypeList)
.map(([key, value]) => ({name: value.value, value: value.value, bu: value.bu}))
.sort((a, b) => a.name.localeCompare(b.name));